import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'shadow',
      d: 'M-6,1h1v0.5h-1zM4.5,1h3v0.5h-3zM-7,1.5h3v0.5h-3zM4,1.5h4v0.5h-4zM-6.5,2h3.5v0.5h-3.5zM3,2h4.5v0.5h-4.5zM-4,2.5h2v0.5h-2zM0.5,2.5h5v0.5h-5z',
    },
    {
      paint: 'rock',
      d: 'M0.5,-13h3v0.5h-3zM-3,-12.5h6.5v0.5h-6.5zM-3,-12h2.5v0.5h-2.5zM-8.5,-8h1v0.5h-1zM8,-8h0.5v0.5h-0.5zM-7.5,-7.5h1v0.5h-1zM6.5,-7.5h1v0.5h-1zM-6.5,-7h1v0.5h-1zM5,-7h1v0.5h-1zM-5,-6.5h1.5v0.5h-1.5zM3.5,-6.5h1v0.5h-1zM-3.5,-6h1.5v0.5h-1.5zM2,-6h1v0.5h-1zM-1.5,-5.5h1.5v0.5h-1.5zM0.5,-5.5h1v0.5h-1zM-7,-1h1.5v0.5h-1.5zM6,-1h1v0.5h-1zM-6,-0.5h1v0.5h-1zM5,-0.5h2.5v0.5h-2.5zM-5,0h1v0.5h-1zM4,0h2.5v0.5h-2.5zM-4,0.5h1.5v0.5h-1.5zM5,0.5h0.5v0.5h-0.5zM-3,1h1.5v0.5h-1.5zM-2,1.5h1.5v0.5h-1.5zM0.5,1.5h1v0.5h-1zM-1,2h3v0.5h-3zM0,2.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'boulder',
      d: 'M-7,-0.5h1v0.5h-1zM-7,0h2v0.5h-2zM-6,0.5h2v0.5h-2zM-5,1h2v0.5h-2zM-4,1.5h2v0.5h-2zM3.5,1.5h0.5v0.5h-0.5zM-3,2h2v0.5h-2zM2.5,2h0.5v0.5h-0.5zM-2,2.5h2v0.5h-2zM-1,3h1v0.5h-1z',
    },
    {
      paint: [
        ['sail', 0.27],
        ['wall', 0.73],
      ],
      d: 'M-3.5,-4.5h0.5v1h-0.5zM-1.5,-4.5h1v0.5h-1zM-3.5,-2.5h0.5v1h-0.5zM-5.5,-2h0.5v0.5h-0.5zM-2,-1h0.5v0.5h-0.5zM-2.5,-0.5h0.5v0.5h-0.5zM-1.5,0h1v0.5h-1z',
    },
    {
      paint: [
        ['shadow', 0.3],
        ['wall', 0.7],
      ],
      d: 'M-5.5,-7h0.5v0.5h-0.5zM-5.5,-6h0.5v0.5h-0.5zM5,-6h1v4h-1zM-3.5,-5.5h0.5v0.5h-0.5zM-5,-5h0.5v0.5h-0.5zM-3,-5h0.5v1h-0.5zM-2,-5h0.5v1.5h-0.5zM1.5,-5h1v0.5h-1zM-5.5,-4.5h1v0.5h-1zM-4,-4.5h0.5v1h-0.5zM0.5,-4.5h1v0.5h-1zM2.5,-4.5h1.5v0.5h-1.5zM-5.5,-4h0.5v0.5h-0.5zM-0.5,-4h1v0.5h-1zM1.5,-4h0.5v0.5h-0.5zM3,-4h1.5v0.5h-1.5zM-5,-3.5h1v0.5h-1zM-3.5,-3.5h0.5v0.5h-0.5zM-1.5,-3.5h2v1h-2zM1,-3.5h0.5v2.5h-0.5zM4,-3.5h0.5v0.5h-0.5zM-5,-3h0.5v0.5h-0.5zM-4,-3h1v0.5h-1zM3.5,-3h0.5v0.5h-0.5zM-4,-2.5h0.5v0.5h-0.5zM-1,-2.5h1.5v1h-1.5zM3,-2.5h1v0.5h-1zM-5,-2h0.5v0.5h-0.5zM3,-2h0.5v0.5h-0.5zM4.5,-2h1.5v0.5h-1.5zM-1.5,-1.5h2v1h-2zM2.5,-1.5h0.5v0.5h-0.5zM4,-1.5h1v0.5h-1zM-3,-1h0.5v1h-0.5zM1,-1h1v0.5h-1zM2.5,-1h1.5v0.5h-1.5zM-2,-0.5h0.5v1h-0.5zM-1,-0.5h1.5v0.5h-1.5zM1.5,-0.5h1.5v0.5h-1.5zM-0.5,0h2.5v0.5h-2.5zM-1,0.5h2v0.5h-2z',
    },
    {
      paint: 'trunk',
      d: 'M4.5,-5.5h0.5v0.5h-0.5zM3,-5h0.5v0.5h-0.5zM-2.5,-4.5h0.5v0.5h-0.5zM2,-4.5h0.5v0.5h-0.5zM-5,-4h0.5v0.5h-0.5zM4.5,-4h0.5v0.5h-0.5zM-4,-3.5h0.5v0.5h-0.5zM2,-2.5h0.5v0.5h-0.5zM-6,-1.5h0.5v0.5h-0.5zM3,-1.5h0.5v0.5h-0.5zM5.5,-1.5h0.5v0.5h-0.5zM-5.5,-1h1v0.5h-1zM-2.5,-1h0.5v0.5h-0.5zM2,-1h0.5v0.5h-0.5zM4.5,-1h1.5v0.5h-1.5zM-4.5,-0.5h1v0.5h-1zM1,-0.5h0.5v0.5h-0.5zM3.5,-0.5h1.5v0.5h-1.5zM-3.5,0h1v0.5h-1zM2.5,0h1v0.5h-1zM-2.5,0.5h1v0.5h-1zM1,0.5h1.5v0.5h-1.5zM-1.5,1h3v0.5h-3zM-0.5,1.5h1v0.5h-1z',
    },
    {
      paint: 'sail',
      d: 'M-4.5,-5h0.5v1h-0.5zM-3,-4h0.5v1h-0.5zM-2,-3.5h0.5v1h-0.5zM-4.5,-3h0.5v1h-0.5zM-3,-2.5h0.5v1h-0.5zM-2,-2h0.5v1h-0.5z',
    },
    {
      paint: 'wall',
      d: 'M-5.5,-5.5h0.5v1h-0.5zM-2.5,-5h0.5v0.5h-0.5zM4,-5h0.5v1h-0.5zM-4.5,-4h0.5v0.5h-0.5zM-1,-4h0.5v0.5h-0.5zM2.5,-4h0.5v1h-0.5zM-5.5,-3.5h0.5v1.5h-0.5zM1.5,-3.5h0.5v1h-0.5zM4,-3h0.5v1h-0.5zM2.5,-2.5h0.5v1h-0.5zM1.5,-2h0.5v1h-0.5zM-5,-1.5h1v0.5h-1zM-3,-1.5h0.5v0.5h-0.5zM-4,-1h1v0.5h-1z',
    },
    {
      paint: 'path',
      d: 'M2.5,0.5h2.5v0.5h-2.5zM1.5,1h3v0.5h-3zM1.5,1.5h2v0.5h-2zM2,2h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['giwa', 0.7],
        ['shadow', 0.3],
      ],
      d: 'M-8.5,-7.5h0.5v0.5h-0.5zM8,-7.5h0.5v0.5h-0.5zM-8.5,-7h2v0.5h-2zM6.5,-7h2v0.5h-2zM-7,-6.5h2v0.5h-2zM5,-6.5h2v0.5h-2zM-4.5,-6h1v0.5h-1zM3,-6h1.5v0.5h-1.5zM-2.5,-5.5h1v0.5h-1zM1.5,-5.5h1.5v0.5h-1.5zM-1,-5h2.5v0.5h-2.5z',
    },
    {
      paint: [
        ['giwa', 0.73],
        ['sail', 0.27],
      ],
      d: 'M-0.5,-12h3v0.5h-3zM-2.5,-11.5h4.5v1h-4.5zM-3.5,-10.5h5.5v0.5h-5.5zM-4,-10h2.5v0.5h-2.5zM-1,-10h2.5v0.5h-2.5zM-4.5,-9.5h6v0.5h-6zM-5.5,-9h6.5v0.5h-6.5zM5.5,-9h0.5v0.5h-0.5zM-6.5,-8.5h7.5v0.5h-7.5zM-7.5,-8h8.5v0.5h-8.5zM7.5,-8h0.5v1h-0.5zM-8,-7.5h0.5v0.5h-0.5zM-6.5,-7.5h7v0.5h-7zM6,-7.5h0.5v1h-0.5zM-5,-7h5.5v0.5h-5.5zM4.5,-7h0.5v1.5h-0.5zM-3.5,-6.5h4v0.5h-4zM3,-6.5h0.5v0.5h-0.5zM-6,-6h0.5v4.5h-0.5zM-5,-6h0.5v0.5h-0.5zM-2,-6h2v0.5h-2zM1.5,-6h0.5v0.5h-0.5zM6,-6h0.5v5h-0.5zM-5,-5.5h1.5v0.5h-1.5zM-3,-5.5h0.5v0.5h-0.5zM0,-5.5h0.5v0.5h-0.5zM3,-5.5h1.5v0.5h-1.5zM-4,-5h1v0.5h-1zM-1.5,-5h0.5v0.5h-0.5zM2.5,-5h0.5v0.5h-0.5zM3.5,-5h0.5v0.5h-0.5zM4.5,-5h0.5v1h-0.5zM-0.5,-4.5h1v0.5h-1zM1.5,-4.5h0.5v0.5h-0.5zM-2.5,-4h0.5v1h-0.5zM-1.5,-4h0.5v0.5h-0.5zM0.5,-4h1v0.5h-1zM2,-4h0.5v1h-0.5zM0.5,-3.5h0.5v3.5h-0.5zM3,-3.5h1v0.5h-1zM4.5,-3.5h0.5v1.5h-0.5zM-3,-3h1v0.5h-1zM2,-3h1.5v0.5h-1.5zM-5,-2.5h0.5v0.5h-0.5zM-2.5,-2.5h1.5v0.5h-1.5zM1.5,-2.5h0.5v0.5h-0.5zM-4.5,-2h1v0.5h-1zM-2.5,-2h0.5v1h-0.5zM-1.5,-2h0.5v0.5h-0.5zM2,-2h0.5v1h-0.5zM3.5,-2h1v0.5h-1zM-5.5,-1.5h0.5v0.5h-0.5zM-4,-1.5h1v0.5h-1zM3.5,-1.5h0.5v0.5h-0.5zM5,-1.5h0.5v0.5h-0.5zM-4.5,-1h0.5v0.5h-0.5zM4,-1h0.5v0.5h-0.5zM-5,-0.5h0.5v0.5h-0.5zM-3.5,-0.5h0.5v0.5h-0.5zM-1.5,-0.5h0.5v0.5h-0.5zM3,-0.5h0.5v0.5h-0.5zM-4,0h0.5v0.5h-0.5zM-2.5,0h0.5v0.5h-0.5zM2,0h0.5v0.5h-0.5zM3.5,0h0.5v0.5h-0.5zM-1.5,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'giwa',
      d: 'M2.5,-12h0.5v0.5h-0.5zM2,-11.5h1.5v1h-1.5zM-3,-11h0.5v0.5h-0.5zM2,-10.5h2v0.5h-2zM-1.5,-10h0.5v0.5h-0.5zM1.5,-10h3v0.5h-3zM1.5,-9.5h3.5v0.5h-3.5zM1,-9h4.5v0.5h-4.5zM1,-8.5h5.5v0.5h-5.5zM1,-8h6.5v0.5h-6.5zM0.5,-7.5h5.5v0.5h-5.5zM0.5,-7h4v0.5h-4zM0.5,-6.5h2.5v0.5h-2.5zM0,-6h1.5v0.5h-1.5z',
    },
  ],
  pixels: 749,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'shadow',
      d: 'M4,1h3.5v0.5h-3.5zM-7,1.5h1.5v0.5h-1.5zM-4.5,1.5h0.5v0.5h-0.5zM3,1.5h5v0.5h-5zM-6.5,2h3.5v0.5h-3.5zM2,2h5.5v0.5h-5.5zM-4,2.5h2v0.5h-2zM0.5,2.5h5v0.5h-5z',
    },
    {
      paint: 'rock',
      d: 'M0.5,-12.5h3v0.5h-3zM-3,-12h6.5v0.5h-6.5zM-3.5,-11.5h3v0.5h-3zM-9.5,-8h1v0.5h-1zM8.5,-8h1v0.5h-1zM-8.5,-7.5h1.5v0.5h-1.5zM7,-7.5h1v0.5h-1zM-7,-7h1.5v0.5h-1.5zM5.5,-7h1v0.5h-1zM-5.5,-6.5h1.5v0.5h-1.5zM4,-6.5h1v0.5h-1zM-3.5,-6h1.5v0.5h-1.5zM2,-6h1.5v0.5h-1.5zM-1.5,-5.5h1.5v0.5h-1.5zM0.5,-5.5h1v0.5h-1zM-7,-1h1.5v0.5h-1.5zM6,-1h1v0.5h-1zM-6,-0.5h1v0.5h-1zM5,-0.5h2.5v0.5h-2.5zM-5,0h1v0.5h-1zM4,0h2.5v0.5h-2.5zM-4,0.5h1.5v0.5h-1.5zM3,0.5h2.5v0.5h-2.5zM-3,1h1.5v0.5h-1.5zM1.5,1h2.5v0.5h-2.5zM-2,1.5h1.5v0.5h-1.5zM0.5,1.5h2.5v0.5h-2.5zM-1,2h3v0.5h-3zM0,2.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'boulder',
      d: 'M-7,-0.5h0.5v0.5h-0.5zM-4,1h1v0.5h-1zM-5,1.5h0.5v0.5h-0.5zM-4,1.5h2v0.5h-2zM-3,2h2v0.5h-2zM-2,2.5h2v0.5h-2zM-1,3h1v0.5h-1z',
    },
    {
      paint: [
        ['sail', 0.27],
        ['wall', 0.73],
      ],
      d: 'M-3.5,-4.5h0.5v1h-0.5zM-1.5,-4.5h1v0.5h-1zM-3.5,-2.5h0.5v1h-0.5zM-5.5,-2h0.5v0.5h-0.5zM-2,-1h0.5v0.5h-0.5zM-2.5,-0.5h0.5v0.5h-0.5zM-1.5,0h1v0.5h-1z',
    },
    {
      paint: [
        ['shadow', 0.3],
        ['wall', 0.7],
      ],
      d: 'M-5.5,-6h0.5v0.5h-0.5zM5,-5.5h1v3.5h-1zM-5,-5h0.5v0.5h-0.5zM-3,-5h0.5v1h-0.5zM-2,-5h0.5v1.5h-0.5zM2,-5h0.5v0.5h-0.5zM-5.5,-4.5h1v0.5h-1zM-4,-4.5h0.5v1h-0.5zM0.5,-4.5h1v0.5h-1zM2.5,-4.5h1.5v0.5h-1.5zM-5.5,-4h0.5v0.5h-0.5zM-0.5,-4h1v0.5h-1zM1.5,-4h0.5v0.5h-0.5zM3,-4h1.5v0.5h-1.5zM-5,-3.5h1v0.5h-1zM-3.5,-3.5h0.5v0.5h-0.5zM-1.5,-3.5h2v1h-2zM1,-3.5h0.5v2.5h-0.5zM4,-3.5h0.5v0.5h-0.5zM-5,-3h0.5v0.5h-0.5zM-4,-3h1v0.5h-1zM3.5,-3h0.5v0.5h-0.5zM-4,-2.5h0.5v0.5h-0.5zM-1,-2.5h1.5v1h-1.5zM3,-2.5h1v0.5h-1zM-5,-2h0.5v0.5h-0.5zM3,-2h0.5v0.5h-0.5zM4.5,-2h1.5v0.5h-1.5zM-1.5,-1.5h2v1h-2zM2.5,-1.5h0.5v0.5h-0.5zM4,-1.5h1v0.5h-1zM-3,-1h0.5v1h-0.5zM1,-1h1v0.5h-1zM2.5,-1h1.5v0.5h-1.5zM-2,-0.5h0.5v1h-0.5zM-1,-0.5h1.5v0.5h-1.5zM1.5,-0.5h1.5v0.5h-1.5zM-0.5,0h2.5v0.5h-2.5zM-1,0.5h2v0.5h-2z',
    },
    {
      paint: 'trunk',
      d: 'M4.5,-5.5h0.5v0.5h-0.5zM3,-5h0.5v0.5h-0.5zM-2.5,-4.5h0.5v0.5h-0.5zM2,-4.5h0.5v0.5h-0.5zM-5,-4h0.5v0.5h-0.5zM4.5,-4h0.5v0.5h-0.5zM-4,-3.5h0.5v0.5h-0.5zM2,-2.5h0.5v0.5h-0.5zM-6,-1.5h0.5v0.5h-0.5zM3,-1.5h0.5v0.5h-0.5zM5.5,-1.5h0.5v0.5h-0.5zM-5.5,-1h1v0.5h-1zM-2.5,-1h0.5v0.5h-0.5zM2,-1h0.5v0.5h-0.5zM4.5,-1h1.5v0.5h-1.5zM-4.5,-0.5h1v0.5h-1zM1,-0.5h0.5v0.5h-0.5zM3.5,-0.5h1.5v0.5h-1.5zM-3.5,0h1v0.5h-1zM2.5,0h1v0.5h-1zM-2.5,0.5h1v0.5h-1zM1,0.5h1.5v0.5h-1.5zM-1.5,1h3v0.5h-3zM-0.5,1.5h1v0.5h-1z',
    },
    {
      paint: 'sail',
      d: 'M-4.5,-5h0.5v1h-0.5zM-3,-4h0.5v1h-0.5zM-2,-3.5h0.5v1h-0.5zM-4.5,-3h0.5v1h-0.5zM-3,-2.5h0.5v1h-0.5zM-2,-2h0.5v1h-0.5z',
    },
    {
      paint: 'wall',
      d: 'M-5.5,-5.5h0.5v1h-0.5zM-2.5,-5h0.5v0.5h-0.5zM4,-5h0.5v1h-0.5zM-4.5,-4h0.5v0.5h-0.5zM-1,-4h0.5v0.5h-0.5zM2.5,-4h0.5v1h-0.5zM-5.5,-3.5h0.5v1.5h-0.5zM1.5,-3.5h0.5v1h-0.5zM4,-3h0.5v1h-0.5zM2.5,-2.5h0.5v1h-0.5zM1.5,-2h0.5v1h-0.5zM-5,-1.5h1v0.5h-1zM-3,-1.5h0.5v0.5h-0.5zM-4,-1h1v0.5h-1z',
    },
    {
      paint: 'path',
      d: 'M-6.5,-0.5h0.5v0.5h-0.5zM-8,0h3v0.5h-3zM-7.5,0.5h3.5v0.5h-3.5zM-6.5,1h2.5v0.5h-2.5zM-5.5,1.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['giwa', 0.7],
        ['shadow', 0.3],
      ],
      d: 'M-9.5,-7.5h1v0.5h-1zM8.5,-7.5h1v0.5h-1zM-9,-7h2v0.5h-2zM7,-7h2v0.5h-2zM-7.5,-6.5h2v0.5h-2zM5.5,-6.5h2v0.5h-2zM-5,-6h1v0.5h-1zM3.5,-6h1.5v0.5h-1.5zM-3,-5.5h1v0.5h-1zM1.5,-5.5h1.5v0.5h-1.5zM-1,-5h2.5v0.5h-2.5z',
    },
    {
      paint: [
        ['giwa', 0.73],
        ['sail', 0.27],
      ],
      d: 'M-0.5,-11.5h3v0.5h-3zM-3,-11h5.5v0.5h-5.5zM-3.5,-10.5h5.5v0.5h-5.5zM-4,-10h6v0.5h-6zM-4.5,-9.5h6v0.5h-6zM-5.5,-9h7v0.5h-7zM-6.5,-8.5h8v0.5h-8zM-8.5,-8h9.5v0.5h-9.5zM8,-8h0.5v1h-0.5zM-7,-7.5h8v0.5h-8zM6.5,-7.5h0.5v1h-0.5zM-5.5,-7h6v0.5h-6zM5,-7h0.5v1h-0.5zM-4,-6.5h4.5v0.5h-4.5zM3.5,-6.5h0.5v0.5h-0.5zM-6,-6h0.5v4.5h-0.5zM-4,-6h0.5v0.5h-0.5zM-2,-6h2v0.5h-2zM1.5,-6h0.5v0.5h-0.5zM5,-6h1.5v0.5h-1.5zM-5,-5.5h2v0.5h-2zM-2,-5.5h0.5v0.5h-0.5zM0,-5.5h0.5v0.5h-0.5zM3,-5.5h1.5v0.5h-1.5zM6,-5.5h0.5v4.5h-0.5zM-4,-5h1v0.5h-1zM-1.5,-5h0.5v0.5h-0.5zM1.5,-5h0.5v1h-0.5zM2.5,-5h0.5v0.5h-0.5zM3.5,-5h0.5v0.5h-0.5zM4.5,-5h0.5v1h-0.5zM-0.5,-4.5h1v0.5h-1zM-2.5,-4h0.5v1h-0.5zM-1.5,-4h0.5v0.5h-0.5zM0.5,-4h1v0.5h-1zM2,-4h0.5v1h-0.5zM0.5,-3.5h0.5v3.5h-0.5zM3,-3.5h1v0.5h-1zM4.5,-3.5h0.5v1.5h-0.5zM-3,-3h1v0.5h-1zM2,-3h1.5v0.5h-1.5zM-5,-2.5h0.5v0.5h-0.5zM-2.5,-2.5h1.5v0.5h-1.5zM1.5,-2.5h0.5v0.5h-0.5zM-4.5,-2h1v0.5h-1zM-2.5,-2h0.5v1h-0.5zM-1.5,-2h0.5v0.5h-0.5zM2,-2h0.5v1h-0.5zM3.5,-2h1v0.5h-1zM-5.5,-1.5h0.5v0.5h-0.5zM-4,-1.5h1v0.5h-1zM3.5,-1.5h0.5v0.5h-0.5zM5,-1.5h0.5v0.5h-0.5zM-4.5,-1h0.5v0.5h-0.5zM4,-1h0.5v0.5h-0.5zM-5,-0.5h0.5v0.5h-0.5zM-3.5,-0.5h0.5v0.5h-0.5zM-1.5,-0.5h0.5v0.5h-0.5zM3,-0.5h0.5v0.5h-0.5zM-4,0h0.5v0.5h-0.5zM-2.5,0h0.5v0.5h-0.5zM2,0h0.5v0.5h-0.5zM3.5,0h0.5v0.5h-0.5zM-1.5,0.5h0.5v0.5h-0.5zM2.5,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'giwa',
      d: 'M2.5,-11.5h1v1h-1zM2,-10.5h2v0.5h-2zM2,-10h2.5v0.5h-2.5zM1.5,-9.5h3.5v0.5h-3.5zM1.5,-9h4.5v0.5h-4.5zM1.5,-8.5h5.5v0.5h-5.5zM1,-8h7v0.5h-7zM1,-7.5h5.5v0.5h-5.5zM0.5,-7h4.5v0.5h-4.5zM0.5,-6.5h3v0.5h-3zM0,-6h1.5v0.5h-1.5z',
    },
  ],
  pixels: 758,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'shadow',
      d: 'M-6,1h1v0.5h-1zM4.5,1h3v0.5h-3zM-7,1.5h3v0.5h-3zM4,1.5h4v0.5h-4zM-6.5,2h3.5v0.5h-3.5zM3,2h4.5v0.5h-4.5zM-4,2.5h2v0.5h-2zM0.5,2.5h5v0.5h-5z',
    },
    {
      paint: 'rock',
      d: 'M2,-14h1v0.5h-1zM-1.5,-13.5h5v0.5h-5zM-3,-13h3.5v0.5h-3.5zM-3,-12.5h1v0.5h-1zM-8,-8h1v0.5h-1zM7.5,-8h0.5v0.5h-0.5zM-7,-7.5h1v0.5h-1zM6,-7.5h1v0.5h-1zM-6,-7h1.5v0.5h-1.5zM4.5,-7h1v0.5h-1zM-4.5,-6.5h1.5v0.5h-1.5zM3,-6.5h1.5v0.5h-1.5zM-3,-6h1.5v0.5h-1.5zM2,-6h1v0.5h-1zM-1.5,-5.5h1.5v0.5h-1.5zM0.5,-5.5h1v0.5h-1zM6,-1h1v0.5h-1zM-5.5,-0.5h0.5v0.5h-0.5zM5,-0.5h2.5v0.5h-2.5zM-5,0h1v0.5h-1zM4,0h2.5v0.5h-2.5zM-4,0.5h1.5v0.5h-1.5zM5,0.5h0.5v0.5h-0.5zM-3,1h1.5v0.5h-1.5zM-2,1.5h1.5v0.5h-1.5zM0.5,1.5h1v0.5h-1zM-1,2h3v0.5h-3zM0,2.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'boulder',
      d: 'M-7,0h2v0.5h-2zM-6,0.5h2v0.5h-2zM-5,1h2v0.5h-2zM-4,1.5h2v0.5h-2zM3.5,1.5h0.5v0.5h-0.5zM-3,2h2v0.5h-2zM2.5,2h0.5v0.5h-0.5zM-2,2.5h2v0.5h-2zM-1,3h1v0.5h-1z',
    },
    {
      paint: [
        ['sail', 0.27],
        ['wall', 0.73],
      ],
      d: 'M-2.5,-5h0.5v0.5h-0.5zM-3.5,-4.5h0.5v1h-0.5zM-1.5,-4.5h1v0.5h-1zM-3.5,-2.5h0.5v1h-0.5zM-2,-1h0.5v0.5h-0.5zM-2.5,-0.5h0.5v0.5h-0.5zM-1.5,0h1v0.5h-1z',
    },
    {
      paint: [
        ['shadow', 0.3],
        ['wall', 0.7],
      ],
      d: 'M5,-6h0.5v4h-0.5zM-3.5,-5.5h0.5v0.5h-0.5zM-3,-5h0.5v1h-0.5zM-2,-5h0.5v1.5h-0.5zM1.5,-5h1v0.5h-1zM-5.5,-4.5h0.5v1.5h-0.5zM0.5,-4.5h1v0.5h-1zM2.5,-4.5h1.5v0.5h-1.5zM-0.5,-4h0.5v0.5h-0.5zM1.5,-4h0.5v0.5h-0.5zM3,-4h1.5v0.5h-1.5zM-4.5,-3.5h0.5v0.5h-0.5zM-1.5,-3.5h1.5v1h-1.5zM1,-3.5h0.5v1.5h-0.5zM4,-3.5h0.5v0.5h-0.5zM3.5,-3h0.5v0.5h-0.5zM-1,-2.5h1v0.5h-1zM3,-2.5h1v0.5h-1zM-5,-2h0.5v0.5h-0.5zM-0.5,-2h0.5v0.5h-0.5zM3,-2h0.5v0.5h-0.5zM4.5,-2h1v0.5h-1zM-1.5,-1.5h1.5v1h-1.5zM1,-1.5h0.5v0.5h-0.5zM2.5,-1.5h0.5v0.5h-0.5zM4,-1.5h1v0.5h-1zM-3,-1h0.5v1h-0.5zM1,-1h1v0.5h-1zM3,-1h1v0.5h-1zM-2,-0.5h0.5v1h-0.5zM-1,-0.5h1v0.5h-1zM1.5,-0.5h1.5v0.5h-1.5zM-0.5,0h0.5v0.5h-0.5zM0.5,0h1.5v0.5h-1.5zM-1,0.5h1v0.5h-1zM0.5,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'trunk',
      d: 'M-7.5,-3h0.5v0.5h-0.5zM-6,-2h0.5v0.5h-0.5zM-5.5,-1h1v0.5h-1zM4.5,-1h1v0.5h-1zM-4.5,-0.5h1v0.5h-1zM3.5,-0.5h1v0.5h-1zM-3.5,0h1v0.5h-1zM2.5,0h0.5v0.5h-0.5zM-2.5,0.5h1v0.5h-1zM1.5,0.5h0.5v0.5h-0.5zM-1.5,1h1v0.5h-1zM0,1h1v0.5h-1z',
    },
    {
      paint: 'sail',
      d: 'M-4.5,-5h0.5v1h-0.5zM-3,-4h0.5v1h-0.5zM-2,-3.5h0.5v1h-0.5zM-4.5,-3h0.5v1h-0.5zM-3,-2.5h0.5v1h-0.5zM-2,-2h0.5v1h-0.5z',
    },
    {
      paint: 'wall',
      d: 'M-5.5,-6h0.5v1.5h-0.5zM4,-5h0.5v1h-0.5zM-4.5,-4h0.5v0.5h-0.5zM-1,-4h0.5v0.5h-0.5zM2.5,-4h0.5v1h-0.5zM1.5,-3.5h0.5v1h-0.5zM4,-3h0.5v1h-0.5zM2.5,-2.5h0.5v1h-0.5zM1.5,-2h0.5v1h-0.5zM-5,-1.5h1v0.5h-1zM-3,-1.5h0.5v0.5h-0.5zM-4,-1h1v0.5h-1z',
    },
    {
      paint: 'path',
      d: 'M2.5,0.5h2.5v0.5h-2.5zM1.5,1h3v0.5h-3zM1.5,1.5h2v0.5h-2zM2,2h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['barrel', 0.38],
        ['trunk', 0.62],
      ],
      d: 'M4.5,-4h0.5v0.5h-0.5zM-4,-3.5h0.5v0.5h-0.5zM-7,-3h1v0.5h-1zM-7.5,-2.5h1.5v1h-1.5zM-7.5,-1.5h2v1h-2zM5.5,-1.5h0.5v0.5h-0.5zM-2.5,-1h0.5v0.5h-0.5zM2,-1h0.5v0.5h-0.5zM-6.5,-0.5h0.5v0.5h-0.5zM3,0h0.5v0.5h-0.5zM1,0.5h0.5v0.5h-0.5zM2,0.5h0.5v0.5h-0.5zM-0.5,1h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['barrel', 0.27],
        ['shadow', 0.3],
        ['trunk', 0.44],
      ],
      d: 'M6,-6.5h0.5v0.5h-0.5zM-6,-3h0.5v1h-0.5zM-5.5,-2h0.5v1h-0.5zM5.5,-1h0.5v0.5h-0.5zM-7,-0.5h0.5v0.5h-0.5zM4.5,-0.5h0.5v0.5h-0.5zM1,1h0.5v0.5h-0.5zM-0.5,1.5h1v0.5h-1z',
    },
    {
      paint: [
        ['barrel', 0.28],
        ['sail', 0.27],
        ['trunk', 0.45],
      ],
      d: 'M-6,-6h0.5v2.5h-0.5zM-5,-6h0.5v0.5h-0.5zM5.5,-6h1v4.5h-1zM-5,-5.5h1.5v0.5h-1.5zM3.5,-5.5h1.5v0.5h-1.5zM-5,-5h0.5v2h-0.5zM-4,-5h1v0.5h-1zM2.5,-5h1.5v0.5h-1.5zM4.5,-5h0.5v1h-0.5zM-4,-4.5h0.5v1h-0.5zM-2.5,-4.5h0.5v1.5h-0.5zM-0.5,-4.5h0.5v0.5h-0.5zM1.5,-4.5h1v0.5h-1zM-1.5,-4h0.5v0.5h-0.5zM0,-4h1.5v0.5h-1.5zM2,-4h0.5v1h-0.5zM-7.5,-3.5h2v0.5h-2zM-3.5,-3.5h0.5v0.5h-0.5zM0,-3.5h1v1.5h-1zM3,-3.5h1v0.5h-1zM4.5,-3.5h0.5v1.5h-0.5zM-5.5,-3h1v1h-1zM-4,-3h2v0.5h-2zM2,-3h1.5v0.5h-1.5zM-4,-2.5h0.5v0.5h-0.5zM-2.5,-2.5h1.5v0.5h-1.5zM1.5,-2.5h1v0.5h-1zM-4.5,-2h1v0.5h-1zM-2.5,-2h0.5v1h-0.5zM-1.5,-2h1v0.5h-1zM0,-2h1.5v0.5h-1.5zM2,-2h0.5v1h-0.5zM3.5,-2h1v0.5h-1zM-4,-1.5h1v0.5h-1zM0,-1.5h1v1h-1zM3,-1.5h1v0.5h-1zM5,-1.5h0.5v0.5h-0.5zM6,-1.5h0.5v0.5h-0.5zM-4.5,-1h0.5v0.5h-0.5zM2.5,-1h0.5v0.5h-0.5zM4,-1h0.5v0.5h-0.5zM-3.5,-0.5h0.5v0.5h-0.5zM-1.5,-0.5h0.5v0.5h-0.5zM0,-0.5h1.5v0.5h-1.5zM3,-0.5h0.5v0.5h-0.5zM-2.5,0h0.5v0.5h-0.5zM0,0h0.5v1h-0.5zM2,0h0.5v0.5h-0.5zM-1.5,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['giwa', 0.7],
        ['shadow', 0.3],
      ],
      d: 'M-8,-7.5h0.5v0.5h-0.5zM7.5,-7.5h0.5v0.5h-0.5zM-8,-7h2v0.5h-2zM4,-7h0.5v0.5h-0.5zM6,-7h2v0.5h-2zM-6.5,-6.5h1.5v0.5h-1.5zM4.5,-6.5h1.5v0.5h-1.5zM-4,-6h0.5v0.5h-0.5zM3,-6h1v0.5h-1zM-2.5,-5.5h1v0.5h-1zM1.5,-5.5h1v0.5h-1zM-1,-5h2v0.5h-2z',
    },
    {
      paint: [
        ['giwa', 0.73],
        ['sail', 0.27],
      ],
      d: 'M0.5,-13h1.5v0.5h-1.5zM2.5,-13h0.5v0.5h-0.5zM-2,-12.5h4v0.5h-4zM-2.5,-12h4.5v1h-4.5zM-3,-11h4.5v1h-4.5zM3.5,-11h0.5v0.5h-0.5zM-4,-10h5.5v0.5h-5.5zM-4.5,-9.5h5.5v0.5h-5.5zM-5.5,-9h6.5v0.5h-6.5zM-6,-8.5h7v0.5h-7zM-7,-8h8v0.5h-8zM7,-8h0.5v1h-0.5zM-7.5,-7.5h0.5v0.5h-0.5zM-6,-7.5h4v0.5h-4zM-1.5,-7.5h2v0.5h-2zM5.5,-7.5h0.5v1h-0.5zM-4.5,-7h5v0.5h-5zM-5,-6.5h0.5v0.5h-0.5zM-3,-6.5h3v0.5h-3zM-4.5,-6h0.5v0.5h-0.5zM-3.5,-6h0.5v0.5h-0.5zM-1.5,-6h1.5v0.5h-1.5zM1.5,-6h0.5v0.5h-0.5zM4,-6h1v0.5h-1zM-3,-5.5h0.5v0.5h-0.5zM0,-5.5h0.5v0.5h-0.5zM2.5,-5.5h1v0.5h-1zM-1.5,-5h0.5v0.5h-0.5zM1,-5h0.5v0.5h-0.5zM0,-4.5h0.5v0.5h-0.5zM-6,-0.5h0.5v0.5h-0.5zM-5,-0.5h0.5v0.5h-0.5zM-4,0h0.5v0.5h-0.5zM3.5,0h0.5v0.5h-0.5z',
    },
    {
      paint: 'giwa',
      d: 'M2,-13h0.5v0.5h-0.5zM2,-12.5h1v1h-1zM-3,-12h0.5v1h-0.5zM2,-11.5h1.5v0.5h-1.5zM-3.5,-11h0.5v1h-0.5zM1.5,-11h2v0.5h-2zM1.5,-10.5h2.5v0.5h-2.5zM1.5,-10h3v0.5h-3zM1,-9.5h4v0.5h-4zM1,-9h4.5v0.5h-4.5zM1,-8.5h5.5v0.5h-5.5zM1,-8h6v0.5h-6zM-2,-7.5h0.5v0.5h-0.5zM0.5,-7.5h5v0.5h-5zM0.5,-7h3.5v0.5h-3.5zM0,-6.5h3v0.5h-3zM0,-6h1.5v0.5h-1.5z',
    },
  ],
  pixels: 775,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
